import type { CatalogProduct } from "@/lib/catalog";
import { formatBRL, pixAmount } from "@/lib/catalog";
import { partnerBuyFaq } from "@/lib/site";

export type FaqItem = {
  question: string;
  answer: string;
};

export const homeFaqs: FaqItem[] = [
  {
    question: "A Progressiva Fashion Gold tem formol?",
    answer:
      "Não. A Fashion Gold é um selante potencializador sem formol, com blend de ácidos orgânicos, proteína de quinoa e óleo Inca. O alisamento acontece pela alteração das ligações de dissulfeto, sem o cheiro típico de progressivas agressivas.",
  },
  {
    question: "A compra é feita neste site?",
    answer:
      "Não processamos pagamento aqui. Escolha o produto nesta página e toque em Comprar na Ybera: você vai para a loja oficial com o desconto especial de parceiro oficial. Estoque, frete, Pix e nota fiscal são da Ybera Group / B2C Brasil Intermediações.",
  },
  {
    question: "Quanto custa a Escova Progressiva Fashion Gold?",
    answer:
      "O preço de referência da 300g e da 500g aparece no topo e nos cards desta página. Promoções da loja oficial mudam; o valor que vale é o do checkout ybera.com na hora do pedido. Há opção de Pix com desconto e parcelamento em até 6x sem juros no checkout da marca.",
  },
  {
    question: "Serve para todos os tipos de cabelo?",
    answer:
      "Sim. A Fashion Gold é indicada para lisos, ondulados, cacheados e crespos, e é compatível com outras químicas. Não altera a cor dos fios. Em cabelos muito sensibilizados, siga o modo de uso e, se possível, conte com orientação profissional.",
  },
  {
    question: "Como aplicar a progressiva Fashion Gold em casa?",
    answer:
      "Lave com o shampoo da linha, seque cerca de 80% dos fios, aplique o selante mecha a mecha a 0,5 cm do couro cabeludo, deixe agir 60 minutos com touca, enxágue bem, seque e pranche mechas finas de 15 a 20 vezes entre 180 °C e 200 °C.",
  },
  {
    question: "Qual o tamanho certo: 300g ou 500g?",
    answer:
      "A Escova 300g é o tamanho mais vendido para uso em casa e cabelos médios. A 500g rende mais em cabelos longos, muito densos ou quando há mais de uma aplicação. Combos com Protect Poo e kit de manutenção prolongam o liso.",
  },
  {
    question: "Quanto tempo dura o liso da Fashion Gold?",
    answer:
      "A marca indica resultado por até 90 dias, conforme porosidade, frequência de lavagem e uso do shampoo e da máscara da linha. Shampoo comum abre cutícula e encurta o efeito do selante.",
  },
  {
    question: "Como saber se o produto é original?",
    answer:
      "O pedido deve ser concluído em ybera.com. Confira o CNPJ da nota fiscal: 35.689.522/0001-27 ou 14.402.098/0001-18. Desconfie de Pix para pessoa física, domínio estranho ou atendimento só por rede social.",
  },
  {
    question: "Gestantes e lactantes podem usar a Fashion Gold?",
    answer:
      "A fórmula é sem formol, mas qualquer química na gravidez e na amamentação pede avaliação de um profissional de saúde. Este site não substitui orientação médica.",
  },
  {
    question: "A Fashion Gold altera a cor do cabelo?",
    answer:
      "Não. O selante não é descolorante nem tinta: não altera a cor dos fios e pode ser usado em cabelos coloridos, realçando o tom natural ou a coloração já existente.",
  },
];

export const progressivaFaqs: FaqItem[] = [
  {
    question: "O que é a Progressiva Fashion Gold da Ybera?",
    answer:
      "É o selante potencializador Fashion Gold, a progressiva sem formol da Ybera Paris. Alinha os fios, reduz volume e frizz e entrega brilho espelhado já na primeira aplicação, com resultado que pode durar até 90 dias conforme o cabelo e a manutenção.",
  },
  {
    question: "A Progressiva Fashion Gold tem formol?",
    answer:
      "Não. A fórmula usa ácidos orgânicos e ativos como proteína de quinoa e óleo Inca. Não tem o cheiro clássico de progressiva com formol.",
  },
  {
    question: "Qual o tamanho certo: 150g, 300g ou 500g?",
    answer:
      "A 300g é o tamanho mais vendido para uso em casa. A 500g rende mais para cabelos longos ou aplicações frequentes. Kits com Protect Poo e manutenção pós-progressiva prolongam o liso.",
  },
  {
    question: "Como aplicar a Escova Progressiva Fashion Gold?",
    answer:
      "Lave, seque 80%, aplique o selante mecha a mecha a 0,5 cm do couro, deixe 60 minutos, enxágue, seque e pranche mechas finas 15 a 20 vezes entre 180 °C e 200 °C. A prancha faz parte do protocolo.",
  },
  {
    question: "A Fashion Gold tem registro na Anvisa?",
    answer:
      "A Escova Progressiva Fashion Gold informa registro Anvisa 25351.630407/2021-40. Outros itens da linha Ybera podem ser isentos conforme a RDC 240/2018. Confira o rótulo no checkout oficial.",
  },
  {
    question: "É compatível com outras químicas?",
    answer:
      "Sim. A Fashion Gold é compatível com outras químicas do mercado e não altera a cor. Fios recém-descoloridos ou muito elásticos pedem teste de mecha e, de preferência, aplicação com profissional.",
  },
  {
    question: "Gestantes e lactantes podem usar?",
    answer:
      "A fórmula é sem formol, mas química na gravidez e na amamentação exige avaliação profissional de saúde. Não substituímos orientação médica.",
  },
  {
    question: "Como comprar a Progressiva Fashion Gold original?",
    answer:
      "Escolha o tamanho e toque em Comprar na Ybera. Você conclui o pedido na loja oficial com o desconto especial de parceiro oficial. Confira o CNPJ da nota (35.689.522/0001-27 ou 14.402.098/0001-18). Pagamento e envio são da Ybera Group.",
  },
  {
    question: "Preciso do kit de manutenção depois da progressiva?",
    answer:
      "Não é obrigatório para o alisamento acontecer, mas o shampoo e a máscara da linha ajudam a não abrir a cutícula e a manter o liso por mais tempo. Shampoo comum tende a encurtar o efeito.",
  },
];

export const oficialFaqs: FaqItem[] = [
  {
    question: "Este site é a fábrica da Ybera?",
    answer:
      "Não. Somos parceiro oficial Ybera da linha Fashion Gold. Você escolhe o produto aqui e compra na loja oficial, com desconto especial. A venda, o estoque, o faturamento e o SAC são da Ybera Group / B2C Brasil Intermediações, no checkout ybera.com.",
  },
  {
    question: "Por que o preço da página pode diferir do checkout?",
    answer:
      "Promoções da loja oficial mudam com frequência. O preço que vale é o de ybera.com no momento do pedido. Pix e parcelas também são definidos lá.",
  },
  {
    question: "Tem nota fiscal e garantia de originalidade?",
    answer:
      "Sim, quando a compra é concluída no checkout oficial da Ybera. Confira o CNPJ 35.689.522/0001-27 ou 14.402.098/0001-18. Produtos fora dos canais oficiais não têm a mesma garantia de procedência.",
  },
  {
    question: "Como funciona o desconto de parceiro oficial?",
    answer:
      "Os botões Comprar na Ybera abrem a loja oficial já com o desconto especial de parceiro oficial. Você escolhe o produto aqui e conclui o pedido em ybera.com, com nota fiscal da marca.",
  },
  {
    question: "Como evitar site falso da Fashion Gold?",
    answer:
      "A Ybera alerta sobre lojas falsas. Conclua o pedido em ybera.com, confira o CNPJ da nota e não pague Pix para pessoa física nem por link de rede social.",
  },
  ...progressivaFaqs.filter((item) =>
    [
      "O que é a Progressiva Fashion Gold da Ybera?",
      "A Progressiva Fashion Gold tem formol?",
      "Qual o tamanho certo: 150g, 300g ou 500g?",
      "Como aplicar a Escova Progressiva Fashion Gold?",
    ].includes(item.question),
  ),
];

function isProgressivaProduct(product: CatalogProduct): boolean {
  return /progressiva|escova/i.test(product.name) && !/manuten/i.test(product.name);
}

function isMaintenanceKit(product: CatalogProduct): boolean {
  return /manuten|cronograma|protect poo|shampoo|m[aá]scara/i.test(product.name);
}

export function getProductFaqs(product: CatalogProduct): FaqItem[] {
  const name = product.name.replace(/\s+/g, " ").trim();
  const priceLabel = product.price != null ? formatBRL(product.price) : "o valor exibido no checkout";
  const pixLabel = product.price != null ? formatBRL(pixAmount(product.price)) : priceLabel;
  const brand = product.categoryNames.includes("Ybera Paris") ? "Ybera Paris" : "Fashion Gold";

  const faqs: FaqItem[] = [
    {
      question: `Como comprar ${name} original?`,
      answer: partnerBuyFaq(brand),
    },
    {
      question: `Quanto custa ${name}?`,
      answer: `A referência atual é ${pixLabel} no Pix (5% off). No cartão, ${priceLabel} em até 6x. Como parceiro oficial, o valor que vale é o da loja Ybera no momento da compra.`,
    },
    {
      question: `${name} é original Ybera?`,
      answer: `Sim, quando o pedido é finalizado em ybera.com. ${name} faz parte da linha ${brand}. Evite marketplaces e Pix para pessoa física que não sejam o checkout oficial da marca.`,
    },
  ];

  if (isProgressivaProduct(product)) {
    faqs.push(
      {
        question: `${name} tem formol?`,
        answer: `Não. ${name} é o selante potencializador Fashion Gold sem formol, com ácidos orgânicos, proteína de quinoa e óleo Inca. Alinha o fio sem o cheiro de progressiva agressiva.`,
      },
      {
        question: `Como aplicar ${name}?`,
        answer: `Lave com o shampoo da linha, seque 80% dos fios, aplique mecha a mecha a 0,5 cm do couro, deixe 60 minutos, enxágue, seque e pranche mechas finas 15 a 20 vezes entre 180 °C e 200 °C.`,
      },
      {
        question: `${name} serve para todos os tipos de cabelo?`,
        answer: `Sim. ${name} é indicado para lisos, ondulados, cacheados e crespos, é compatível com outras químicas e não altera a cor dos fios. Cabelos muito sensibilizados pedem teste de mecha.`,
      },
      {
        question: `Quanto tempo dura o efeito de ${name}?`,
        answer: `A marca indica até 90 dias, conforme porosidade e manutenção. Usar o shampoo e a máscara da linha Fashion Gold ajuda a preservar o liso; shampoo comum tende a encurtar o resultado.`,
      },
    );
  } else if (isMaintenanceKit(product)) {
    faqs.push(
      {
        question: `${name} alisa o cabelo?`,
        answer: `Não. ${name} é produto de lavagem, hidratação ou manutenção. O alisamento vem da Escova Progressiva Fashion Gold. Esta linha ajuda a prolongar o liso e a cuidar da fibra depois da aplicação.`,
      },
      {
        question: `Posso usar ${name} com a progressiva Fashion Gold?`,
        answer: `Sim. ${name} foi pensado para a rotina Fashion Gold / Ybera. Usar shampoo da linha em vez de shampoo comum reduz a abertura da cutícula e ajuda a manter o efeito do selante.`,
      },
      {
        question: `Como usar ${name}?`,
        answer: `Siga o modo de uso do rótulo no checkout Ybera. Em geral: aplique nos fios úmidos após a lavagem, deixe o tempo indicado e enxágue se o produto não for leave-in. Não substitui a prancha da progressiva.`,
      },
    );
  } else {
    faqs.push(
      {
        question: `${name} substitui a progressiva?`,
        answer: `${name} é um produto da linha ${brand} para cuidado ou finalização. Para alisar com o protocolo Fashion Gold, o produto é a Escova Progressiva. Dá para usar ${name} na mesma rotina, no passo certo.`,
      },
      {
        question: `Como usar ${name}?`,
        answer: `Siga o modo de uso descrito nesta página e no rótulo em ybera.com. Aplique a quantidade indicada no comprimento ou no couro, conforme o tipo de produto, e não misture com alisantes de outra marca no mesmo passo.`,
      },
    );
  }

  faqs.push({
    question: `Gestantes podem usar ${name}?`,
    answer: `A linha Fashion Gold / Ybera inclui fórmulas sem formol, mas qualquer cosmética na gravidez e na amamentação pede avaliação de um profissional de saúde. Não substituímos orientação médica.`,
  });

  return faqs;
}

export const perfumeFaqs: FaqItem[] = [
  {
    question: "O perfume capilar Ana Castela alisa o cabelo?",
    answer:
      "Não. Os perfumes capilares Oriental Seduction, Secret Garden e Floral Fusion perfumam, reduzem o estático e dão brilho. Para alisar, o produto continua sendo a Escova Progressiva Fashion Gold.",
  },
  {
    question: "Quais são as três fragrâncias da coleção Boiadeira?",
    answer:
      "Oriental Seduction (efeito sensual), Secret Garden (jardim e frescor) e Floral Fusion (floral do dia a dia). O kit leve 3 reúne os três frascos de 50ml.",
  },
  {
    question: "Como aplicar o perfume capilar Fashion Gold?",
    answer:
      "Com os fios secos ou quase secos, borrife no comprimento e nas pontas, a uma distância de palmo. Evite a raiz se o cabelo for oleoso. Não enxágue.",
  },
  {
    question: "O kit vale mais que comprar um frasco só?",
    answer:
      "O kit da coleção Ana Castela costuma sair com condição de leve 3 no checkout Ybera. Um frasco de 50ml serve para testar a fragrância favorita.",
  },
  {
    question: "Como comprar o perfume Ana Castela original?",
    answer:
      "Os botões desta página abrem a loja oficial Ybera com o desconto especial de parceiro oficial. Pagamento, estoque e nota fiscal são da Ybera Group. Confira o CNPJ 35.689.522/0001-27 ou 14.402.098/0001-18.",
  },
  {
    question: "O perfume capilar deixa o cabelo pesado?",
    answer:
      "A dose certa é poucas pulverizações no comprimento. Excesso na raiz pode pesar. Comece com duas ou três borrifadas e ajuste.",
  },
];

export const antiquedaFaqs: FaqItem[] = [
  {
    question: "Como os produtos da linha 100Tímetros tratam a queda capilar?",
    answer:
      "A linha 100Tímetros, dos laboratórios Ybera Paris, trata de fora para dentro e de dentro para fora: shampoo e condicionador na lavagem, tônico no couro cabeludo e cápsulas Softgel como suplemento. O objetivo é fortalecer o bulbo, reduzir a queda e dar mais densidade ao fio.",
  },
  {
    question: "Qual a função de cada produto (shampoo, condicionador, tônico e cápsulas)?",
    answer:
      "O shampoo age no bulbo e na musculatura do couro. O condicionador protege a fibra no dia a dia. O tônico ativa a circulação no couro e não enxágua. As cápsulas Softgel complementam com nutrientes como biotina, zinco e niacina. Usar a linha completa potencializa o resultado, mas cada item tem benefício sozinho.",
  },
  {
    question: "As cápsulas Softgel substituíram o kit antigo com PPC-600?",
    answer:
      "Sim. O kit 90 cápsulas + PPC-600 Colágeno saiu do catálogo Ybera. O sucessor das cápsulas é o Kit 100Timetros 90 Cápsulas Softgel (cabelo, pele e unhas). O combo com tônico e o combo da linha antiqueda + 3 potes continuam à venda no checkout oficial.",
  },
  {
    question: "Como usar o tônico 100Tímetros?",
    answer:
      "Com os fios secos ou úmidos, aplique no couro cabeludo e massageie com a ponta dos dedos em movimentos circulares. Não enxágue. O shampoo e o condicionador seguem a lavagem: espuma, enxágue; condicionador 3 minutos e enxágue.",
  },
  {
    question: "Os ativos e o sistema PLEX são seguros?",
    answer:
      "Calcium gluconate / zinc chloride, extrato de Scutellaria baicalensis e o sistema PLEX fazem parte da fórmula cosmética da linha. Cápsulas são suplemento alimentar, não medicamento. Gestantes, lactantes e crianças só devem usar suplemento com orientação de nutricionista ou médico.",
  },
  {
    question: "Como comprar o 100Tímetros original?",
    answer:
      "Escolha o produto e toque em Comprar na Ybera: você vai para a loja oficial com o desconto especial de parceiro oficial. Pagamento, estoque e nota fiscal são da Ybera Group. Confira o CNPJ 35.689.522/0001-27 ou 14.402.098/0001-18.",
  },
];

export const cronogramaFaqs: FaqItem[] = [
  {
    question: "O cronograma Fashion Gold mudou de nome?",
    answer:
      "Sim. Na loja oficial Ybera o kit aparece como Cuidados Profundos: as três máscaras (medula, córtex e cutícula) com shampoo 500ml. A função continua sendo hidratação, nutrição e reconstrução.",
  },
  {
    question: "O que é o cronograma capilar?",
    answer:
      "É a alternância de hidratação, nutrição e reconstrução entre as lavagens, de acordo com o que o fio precisa. O Fashion Gold organiza isso em três máscaras, uma para cada camada do cabelo.",
  },
  {
    question: "O cronograma alisa o cabelo?",
    answer:
      "Não. Ele trata e ajuda a manter o efeito da Escova Progressiva Fashion Gold. Para alisar, o produto continua sendo o selante da progressiva.",
  },
  {
    question: "O que vem no kit Cuidados Profundos?",
    answer:
      "O kit Cuidados Profundos + shampoo 500ml reúne as três máscaras (medula, córtex e cutícula) e o shampoo. O óleo de mirra continua disponível à parte na linha Ybera.",
  },
  {
    question: "Como comprar o cronograma original?",
    answer:
      "Escolha o produto e toque em Comprar na Ybera: você vai para a loja oficial com o desconto especial de parceiro oficial. Pagamento, estoque e nota fiscal são da Ybera Group.",
  },
  {
    question: "O que é o efeito build-up?",
    answer:
      "É o acúmulo de resíduo de produto no fio, que deixa o cabelo opaco e pesado. A linha Fashion Gold foi formulada para absorção sem esse acúmulo típico de máscara repetida.",
  },
];

export const velloFaqs: FaqItem[] = [
  {
    question: "O Soro Vital Vello ainda existe? Qual o nome na Ybera?",
    answer:
      "Sim. Na loja oficial o tônico aparece como Soro Vello Alfa-Lactobaby® 90ml (antigo Soro Vital Vello). É o mesmo tratamento da linha Vello, com embalagem atualizada.",
  },
  {
    question: "Para que serve o Soro Vello Alfa-Lactobaby?",
    answer:
      "É um tônico de uso diário, sem enxágue, para queda, afinamento, falhas e sinais de calvície. Age no couro cabeludo: reativa folículos, fortalece a raiz e estimula o nascimento de fios novos. Não é progressiva e não alisa.",
  },
  {
    question: "Como usar o soro?",
    answer:
      "Depois de lavar e condicionar, borrife no couro cabeludo, massageie até absorver e não enxágue. Indicado para uso diário. O shampoo e a máscara da linha Vello preparam o couro e o comprimento.",
  },
  {
    question: "Em quanto tempo aparece resultado?",
    answer:
      "A Ybera indica resultado visível em cerca de 8 semanas com uso correto. Avaliações na loja oficial relatam fios novos e menos queda já nas primeiras semanas, mas cada couro responde no seu tempo.",
  },
  {
    question: "Posso usar com a Progressiva Fashion Gold?",
    answer:
      "Sim. O soro trata a raiz; a Fashion Gold alinha o comprimento. Não há incompatibilidade com químicas em geral. Gestantes e lactantes só com orientação médica.",
  },
  {
    question: "Qual a diferença do soro, do combo e do kit com cápsulas?",
    answer:
      "O soro 90ml é o tônico sozinho. O combo da linha reúne soro, shampoo 250ml e máscara 200g. O shampoo + máscara trata lavagem e hidratação. O kit soro + 30 cápsulas 100Tímetros Softgel soma o tônico com o suplemento da Fashion Gold.",
  },
  {
    question: "Como comprar o Soro Vello original?",
    answer:
      "Escolha o produto e toque em Comprar na Ybera: você vai para a loja oficial com o desconto especial de parceiro oficial. Pagamento, estoque e nota fiscal são da Ybera Group. Confira o CNPJ 35.689.522/0001-27 ou 14.402.098/0001-18.",
  },
];

export const oleoFaqs: FaqItem[] = [
  {
    question: "Para que serve o Óleo de Mirra Ybera?",
    answer:
      "É o finalizador Pro Repair da Ybera Paris para hidratar e nutrir os fios. A mirra vem da Commiphora. Poucas gotas no comprimento devolvem brilho, maciez e ajudam a selar pontas.",
  },
  {
    question: "O que o óleo faz no cabelo?",
    answer:
      "Rico em nutrientes e antioxidantes, fortalece, reduz quebra e frizz e deixa o fio mais brilhante. Serve como tratamento de choque ou manutenção diária, em todos os tipos de cabelo.",
  },
  {
    question: "Pode usar o Óleo de Mirra no rosto?",
    answer:
      "A marca indica uso também na pele, por antioxidantes e propriedades anti-inflamatórias. Qualquer aplicação no rosto pede teste e, se houver dúvida, orientação de um profissional de saúde. Este site não substitui consulta médica.",
  },
  {
    question: "Posso usar todos os dias?",
    answer:
      "Sim. Aplique no comprimento depois de lavar, sem enxágue. Evite a raiz se o cabelo for oleoso. Também potencializa o cronograma Cuidados Profundos e a progressiva Fashion Gold.",
  },
  {
    question: "Qual tamanho escolher: 15ml, 60ml ou 90ml?",
    answer:
      "O 15ml é para experimentar. O 60ml rende no dia a dia. O 90ml é o tamanho mais usado; existe refil de 90ml. O combo com leave-in Universal e o kit MirraCura reúnem a linha.",
  },
  {
    question: "Como comprar o Óleo de Mirra original?",
    answer:
      "Escolha o produto e toque em Comprar na Ybera: você vai para a loja oficial com o desconto especial de parceiro oficial. Pagamento, estoque e nota fiscal são da Ybera Group.",
  },
];
